module.exports = __webpack_public_path__ + "img/img-parts-senaka02.ac5adc74.png";